import { apiRequest } from './apiClient';

export const fetchCollections = async (options = {}) => {
  const params = new URLSearchParams();
  if (options.scopePicker) {
    params.set('scope_picker', 'true');
  }
  if (typeof options.search === 'string' && options.search.trim()) {
    params.set('search', options.search.trim());
  }
  if (Number.isInteger(options.page) && options.page >= 0) {
    params.set('page', String(options.page));
  }
  if (Number.isInteger(options.limit) && options.limit > 0) {
    params.set('limit', String(options.limit));
  }
  if (Array.isArray(options.selectedIds) && options.selectedIds.length > 0) {
    params.set('selected_ids', options.selectedIds.map((value) => String(value)).join(','));
  }

  const query = params.toString();
  return apiRequest(`/api/v1/collections${query ? `?${query}` : ''}`);
};

export const fetchProjectCollections = async (projectId) => {
  return apiRequest(`/api/v1/projects/${encodeURIComponent(projectId)}/collections`);
};
